import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import DashboardLayout from '../../components/DashboardLayout';
import { SessionCard } from './CoachCompanyPage';

export default function CoachSessionsPage() {
  const { profile } = useAuth();
  const [allSessions, setAllSessions] = useState([]);
  const [companies, setCompanies]     = useState({});
  const [loading, setLoading]         = useState(true);
  const [expanded, setExpanded]       = useState(null);
  const [showPicker, setShowPicker]   = useState(false);
  const [pickerCompanyId, setPickerCompanyId] = useState('');

  useEffect(() => {
    if (!profile?.uid) return;
    async function load() {
      try {
        const cSnap = await getDocs(query(collection(db, 'companies'), where('coachId', '==', profile.uid)));
        const compMap = {};
        cSnap.docs.forEach(d => { compMap[d.id] = d.data(); });
        setCompanies(compMap);

        const sessions = [];
        for (const [compId] of Object.entries(compMap)) {
          const sSnap = await getDocs(
            query(collection(db, 'companies', compId, 'coachingSessions'), orderBy('sessionDate', 'desc'))
          );
          sSnap.docs.forEach(d => sessions.push({ id: d.id, companyDocId: compId, ...d.data() }));
        }
        sessions.sort((a, b) => {
          const da = a.sessionDate?.toDate ? a.sessionDate.toDate() : new Date(a.sessionDate);
          const db2 = b.sessionDate?.toDate ? b.sessionDate.toDate() : new Date(b.sessionDate);
          return db2 - da;
        });
        setAllSessions(sessions);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    }
    load();
  }, [profile]);

  return (
    <DashboardLayout>
      <div className="gm-page">
        <div className="gm-page-header">
          <div>
            <h1 className="gm-page-title">All Sessions</h1>
            <p className="gm-page-sub">Sessions across all your assigned companies</p>
          </div>
          {!loading && Object.keys(companies).length > 0 && (
            <button className="gm-btn gm-btn-primary" onClick={() => setShowPicker(true)}>
              + Log new session
            </button>
          )}
        </div>

        {showPicker && (
          <div className="gm-config-card" style={{ marginBottom: 24 }}>
            <div className="gm-config-label">Which company is this session for?</div>
            <div style={{ display: 'flex', gap: 12, marginTop: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <select
                value={pickerCompanyId}
                onChange={e => setPickerCompanyId(e.target.value)}
                style={{ padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 6, fontSize: '0.875rem', fontFamily: 'inherit', minWidth: 240 }}
              >
                <option value="">— Select company —</option>
                {Object.entries(companies).map(([id, c]) => (
                  <option key={id} value={id}>{c.name}</option>
                ))}
              </select>
              <button className="gm-btn gm-btn-primary gm-btn-sm"
                disabled={!pickerCompanyId}
                onClick={() => { window.location.href = `/scaling/coach/company/${pickerCompanyId}#log-session`; }}>
                Continue
              </button>
              <button className="gm-btn gm-btn-outline gm-btn-sm" onClick={() => setShowPicker(false)}>
                Cancel
              </button>
            </div>
          </div>
        )}

        {loading && <div className="gm-loading"><div className="gm-spinner" /></div>}

        {!loading && allSessions.length === 0 && (
          <div className="gm-empty-state"><p>No sessions logged yet.</p></div>
        )}

        {!loading && allSessions.map(session => (
          <div key={session.id}>
            <div className="gm-session-company-tag">
              <a href={`/scaling/coach/company/${session.companyDocId}`}>
                🏢 {companies[session.companyDocId]?.name}
              </a>
            </div>
            <SessionCard
              session={session}
              companyId={session.companyDocId}
              isExpanded={expanded === session.id}
              onToggle={() => setExpanded(expanded === session.id ? null : session.id)}
              onToggleAction={() => {}}
              isCoach={true}
              profile={profile}
            />
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
